<script setup lang="ts">

import {ExtendedUser} from "@/types";
import {useUserAvatar, useUserCover} from "@/composables/avatar";

interface Props {
    user: ExtendedUser
    mobile: boolean
}

const props = defineProps<Props>()
</script>

<template>
    <div>
        <v-avatar
            v-if="!mobile"
            size="auto"
            class="mr-5 border-md"
        >
            <img
                :src="useUserCover(props.user.name)"
                alt="avatar"
            >
        </v-avatar>
        <v-list density="comfortable">
            <v-list-item
                density="comfortable"
                lines="three"
            >
                <template
                    v-if="mobile"
                    #prepend
                >
                    <v-avatar
                        size="auto"
                        class="mr-5"
                    >
                        <img
                            :src="useUserAvatar(user.name)"
                            alt="avatar"
                        >
                    </v-avatar>
                </template>
                <v-list-item-title class="text-h5 font-weight-bold py-1">
                    {{ user.full_name }}
                </v-list-item-title>
                <v-list-item-subtitle
                    class="text-h6 py-1"
                    style="min-height: fit-content !important;"
                >
                    {{ user.name }}
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item
                prepend-icon="mdi-folder-outline"
                :slim="true"
                density="compact"
                class="text-body-2 mb-3"
            >
                <div class="text-grey">
                    <span class="font-weight-bold text-black">{{ user.projects_count }}</span> projects
                </div>
            </v-list-item>
            <v-list-item
                v-if="user.company"
                prepend-icon="mdi-domain"
                :slim="true"
                density="compact"
                class="text-body-2"
                height="12"
            >
                {{ user.company }}
            </v-list-item>
            <v-list-item
                v-if="user.location"
                prepend-icon="mdi-map-marker-outline"
                :slim="true"
                density="compact"
                class="text-body-2"
            >
                {{ user.location }}
            </v-list-item>
            <v-list-item
                prepend-icon="mdi-email-outline"
                :slim="true"
                density="compact"
                class="text-body-2"
            >
                <a
                    :href="`mailto:${user.email}`"
                    class="text-decoration-none text-black underline-hover"
                >{{ user.email }}</a>
            </v-list-item>
            <v-list-item
                v-if="user.website"
                prepend-icon="mdi-link"
                :slim="true"
                density="compact"
                class="text-body-2"
            >
                <a
                    :href="user.website"
                    target="_blank"
                    class="text-decoration-none text-black underline-hover"
                >{{ user.website }}</a>
            </v-list-item>
        </v-list>
    </div>
</template>

<style scoped>
.underline-hover:hover {
    text-decoration: underline !important;
}
</style>
